// @flow

import * as React from "react";
import ReactDOMServer from "react-dom/server";

class StackedTable {
    el: HTMLElement;
    container: ?HTMLElement;
    originalTable: ?HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        this.container = el.querySelector(".stacked-table__small");
        this.originalTable = el.querySelector(".stacked-table__big table");
        this.build();
    }

    build = () => {
        const originalTable = this.originalTable;
        const container = this.container;
        if (originalTable && container) {
            // Build array of thead th elements - this is is the foundation for each tbody element in the table
            const headers = Array.from(
                originalTable.querySelectorAll("thead th")
            );

            // Pull out each tr inside tbody elements, these become each subrow in the new table
            const rowEls = Array.from(
                originalTable.querySelectorAll("tbody tr")
            );

            // Pull out each th or td in each rowEl to become the inner cells within the new table
            const rows: HTMLElement[][] = Array.from(
                rowEls.map((row: HTMLElement): Array<HTMLElement> =>
                    Array.from(row.querySelectorAll("th, td"))
                )
            );

            container.insertAdjacentHTML(
                "beforeend",
                ReactDOMServer.renderToStaticMarkup(
                    <table>
                        {rows.map(
                            (
                                row: HTMLElement[],
                                rowIndex: number
                            ): React.Node => (
                                <tbody key={rowIndex}>
                                    {headers.map(
                                        (
                                            header: HTMLElement,
                                            headerIndex: number
                                        ): React.Node => {
                                            const content = row[headerIndex];
                                            const contentText = content
                                                ? content.textContent
                                                : "";
                                            const ContentTag = content
                                                ? content.tagName.toLowerCase()
                                                : "td";
                                            return (
                                                <tr
                                                    key={`${rowIndex}-${headerIndex}`}
                                                >
                                                    <th>
                                                        {header.textContent}
                                                    </th>
                                                    <ContentTag>
                                                        {contentText}
                                                    </ContentTag>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            )
                        )}
                    </table>
                )
            );
        }
    };
}

const els = document.querySelectorAll(".stacked-table");
els.forEach((el: HTMLElement) => {
    new StackedTable(el);
});
